import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import de from './locales/de/translation.json';
import en from './locales/en/translation.json';
import tr from './locales/tr/translation.json';
import ru from './locales/ru/translation.json';

const resources = {
  de: { translation: de },
  en: { translation: en },
  tr: { translation: tr },
  ru: { translation: ru }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
